import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';

import { useGeolocation } from '~/hooks/useGeolocation';

import { orderStore } from '~/stores';

import Icon from '../../Icon/Icon';

import { deliveryAddressStore } from '../DeliveryAddressStore';

import styles from './Geolocation.module.scss';

const Geolocation = () => {
  const { requestLocation } = useGeolocation();

  return (
    <button
      className={classes([
        'modal-delivery-address__map-geolocation',
        styles.button,
      ])}
      disabled={
        deliveryAddressStore.isAwaitGeolocation ||
        deliveryAddressStore.isLoading ||
        orderStore.isETALoading
      }
      onClick={requestLocation}
    >
      {deliveryAddressStore.isAwaitGeolocation ||
      deliveryAddressStore.isLoading ||
      orderStore.isETALoading ? (
        <span className="spinner" />
      ) : (
        <Icon type="geolocation" size={24} />
      )}
    </button>
  );
};

export default observer(Geolocation);
